// themes/atlantic/styles.js

export const styles = {
  container: {
    backgroundColor: 'bg-gradient-to-br from-[#0a192f] via-[#003349] to-[#005f73]', // Deep ocean gradient
    textColor: 'text-white',
    backgroundAnimation: 'animate-wave-pattern',
  },
  header: {
    backgroundColor: 'bg-transparent',
    textColor: 'text-white',
    titleColor: 'text-white font-semibold',
    subtitleColor: 'text-white opacity-75 text-sm',
    closeButtonColor: 'text-white opacity-70 hover:opacity-100 transition-colors duration-200',
  },
  messages: {
    bot: {
      background: 'bg-blue-900 bg-opacity-50 backdrop-blur-sm',
      text: 'text-gray-100',
      animation: 'animate-float',
    },
    user: {
      background: 'bg-teal-600 bg-opacity-80 backdrop-blur-sm',
      text: 'text-white',
      animation: 'animate-float',
    },
  },
  input: {
    backgroundColor: 'bg-blue-900 bg-opacity-50 backdrop-blur-sm',
    textColor: 'text-white',
    placeholderColor: 'text-white opacity-75',
    sendButtonColor: 'text-white opacity-70 hover:opacity-100 transition-colors duration-200',
    focus: 'ring-2 ring-white ring-opacity-50',
  },
  avatar: {
    background: 'bg-teal-500 bg-opacity-80 backdrop-blur-sm',
    text: 'text-white',
    animation: 'animate-bubble',
  },
  typingIndicator: {
    container: 'bg-blue-900 bg-opacity-50 backdrop-blur-sm',
    dots: 'bg-teal-300 animate-bubble-float',
  },
  footer: {
    text: 'text-blue-200',
    link: 'text-teal-300 hover:text-teal-100 transition-colors duration-200',
  },
};
